const pluginCodes = {
  pgin_EssilorOpsys: 0, //Essilor Opsys
  pgin_EssilorOpsysWeb: 1, //Essilor Opsys Web
  pgin_HoyaLog: 2, //HoyaLog
  pgin_HoyaILog: 3, //HoyaILog
  pgin_CooperVision: 4, //CooperVision
  pgin_CibaVisionEasy: 5, //CibaVision Easy
  pgin_SafiloEDI: 6, //Safilo EDI
  pgin_SafiloSmile: 7, //Safilo Smile
  pgin_ZeissiCom: 8, //Zeiss i.Com
  pgin_TutorVision: 9, //TutorVISION
  pgin_VisuReal: 10, //VisuReal
  pgin_Visioffice: 11, //VisiOffice
  pgin_Activisu: 12, //ActiVisu
  pgin_RVTZeiss: 13, //RVT Zeiss
  pgin_ImpressionIST: 14, //ImpressionIST
  pgin_IndividualStudio: 15, //SBM Individual Studio
  pgin_WinFit: 16, //WinFit
  pgin_MagicMirror: 17, //Magic Mirror
  pgin_TopConTRK_1P: 18, //Topcon TRK-1P
  pgin_BLUAnalisi: 19, //BluAnalysis
  pgin_Ecomm_Base: 20, //E-commerce Base
  pgin_ImportClientiXLS: 21, //Import Clienti XLS
  pgin_ZeissLogOn: 22, //Zeiss LogOn
  pgin_Rfid: 23, //Rfid
  pgin_DirectMarketing: 24, //Direct Marketing
  pgin_LuxotticaStars: 25, //Luxottica Stars
  pgin_FocusLab: 26, //Focus Lab
  pgin_ExportContabilita: 27, //Export Contabilità
  pgin_Nakymanet: 28, //Nakymanet
  pgin_iFocusServer: 29, //iFOCUS10Server
  pgin_CSO_Phoenix: 30, //CSO Phoenix
  pgin_SellOut: 31, //SellOut
  pgin_Syncro: 32, //Syncro
  pgin_FatturaPA: 33, //FatturaPA
  pgin_2WIN: 34, //2WIN Adaptica
  pgin_Console10: 35, //FOCUS10Console
  pgin_Cartier: 36, //Modulo Cartier
  pgin_TaxRefund: 37, //Tax Refund
  pgin_WinOnline: 38, //WinOnline
  pgin_Italianvision: 39, //Italianvision
  pgin_TopconOCT: 40, //Topcon OCT
  pgin_SbmIpad: 41, //SBM iPad
  pgin_EssilorDiretto: 42, //Essilor Diretto
  pgin_GViGreenTransitions: 43, //GV iGreen
  pgin_IlMioOttico: 44, //Il Mio Ottico
  pgin_BluCassa: 45, //BluCassa
  pgin_ModuloTS: 46, //ModuloTS
  pgin_ZeissVisustore: 47, //Zeiss Visustore
  pgin_LuxotticaRXO: 48, //Luxottica RXO
  pgin_IlMioOtticoSingolo: 49, //Il Mio Ottico (S)
  pgin_RacSystem: 50, //Rac System
  pgin_GFK: 51, //GFK
  pgin_Ecomm_Pro: 52, //Ecommerce PRO
  pgin_Luxottica_NOOS: 53, //Luxottica NOOS
  pgin_FatturaB2B: 54, //Fattura B2B (FOCUS FE)
  pgin_Tracer: 55, //Tracer
  pgin_Essibox2: 56, //Essibox 2.0
  pgin_ItalLenti: 57, //ItalLenti
  pgin_BluSign: 58, //BLU Sign
  pgin_ShamirOnline: 59, //Shamir Online
  pgin_BBGRFTP: 60, //BBGR Acuitis
  pgin_Visuconsult: 61, //Visuconsult
  pgin_ZeissLAC: 62, //Zeiss Lac
  pgin_VEM: 63, //VEM
  pgin_Jakala: 64, //Reporting Dashboard
  pgin_FocusRT1: 65, //FocusRT1
  pgin_FocusRT2: 66, //FocusRT2
  pgin_FocusRT3: 67, //FocusRT3
  pgin_FocusRT4: 68, //FocusRT4
  pgin_FocusRT5: 69, //FocusRT5
  pgin_FocusRTPlus: 70, //FocusRTPlus
  pgin_FocusWEB: 71, //FOCUS WEB
  pgin_FocusCRM: 74, //FOCUS CRM
  pgin_ZeissBusta: 75,
  pgin_Noleggio: 76,
  pgin_MarcolinMore: 77,
  pgin_NoleggioVG: 78,
  pgin_OxoData: 79,
  pgin_HoyaWeb: 80,
  pgin_MersyDiretto: 81,
  pgin_Visuconsult500: 82,
  pgin_Cnxt: 83,
  pgin_Bridge: 84,
  pgin_BluBooking: 85,
  pgin_BluReport: 86,
  pgin_Pegaso: 87,
  pgin_FocusRT1SaaS: 88,
  pgin_FocusRT2SaaS: 89,
  pgin_FocusRT3SaaS: 90,
  pgin_FocusRT4SaaS: 91,
  pgin_FocusRT5SaaS: 92,
  pgin_FocusRTPlusSaaS: 93,
  pgin_AgendaWeb: 97,

  // nuove aggiunte
  pgin_FocusCloudDB: 106, //Focus Cloud DB
  pgin_FocusCloudWP: 107, //Focus Cloud WP
  pgin_WhatsApp: 108, //WhatsApp
  pgin_WhatsAppCredit: 109, //WhatsApp Credit
  pgin_DUMMY_110: 110, //DUMMY
  pgin_Sms: 111, //Sms
  pgin_SmsCredit: 112, //Sms Credit
  pgin_EMail: 113, //EMail
  pgin_EMailCredit: 114, //EMail Credit
  pgin_AdvancedAI: 115, //Advanced A.I.
  pgin_PremiumAI: 116, //Premium A.I.
  pgin_AdvancedBI: 117, //Advanced B.I.
  pgin_PremiumBI: 118, //Premium B.I.
  pgin_API: 119, //API
  pgin_DUMMY_120: 120, //DUMMY
  pgin_ReplicaDB: 121, //Replica DB
  pgin_FocusCloudAPP: 122, //Focus Cloud APP
  pgin_FocusCloudFcSession: 123, //Focus Cloud APP
  pgin_CloudConnector: 124, //Focus Cloud APP
  pgin_CrmBase: 125, //Focus Cloud APP
  pgin_CloudDataExchange: 126, //Cloud Data Exchange
  pgin_Webhook: 127, //Webhook

  // altre chiavi strane ma esistenti
  chiaveplugin_free: 7850,
  pgin_Assistenza: 99,
  pgin_GVHerzach: 103,

  pgin_RefSystem: 72,
  pgin_FrastemaKit: 73,
  pgin_FocusCRMStart: 94,
  pgin_CloudStorage: 95,
  pgin_ZeissVisionPlus: 96,
  pgin_CloudOrder: 98,
  pgin_OnePortal: 101,
  pgin_SmartTraffic: 102,
};

export const pluginDesc = {
  pgin_EssilorOpsys: 'Essilor Opsys',
  pgin_EssilorOpsysWeb: 'Essilor Opsys Web',
  pgin_HoyaLog: 'HoyaLog',
  pgin_HoyaILog: 'HoyaILog',
  pgin_CooperVision: 'CooperVision',
  pgin_CibaVisionEasy: 'CibaVision Easy',
  pgin_SafiloEDI: 'Safilo EDI',
  pgin_SafiloSmile: 'Safilo Smile',
  pgin_ZeissiCom: 'Zeiss i.Com',
  pgin_TutorVision: 'TutorVISION',
  pgin_VisuReal: 'VisuReal',
  pgin_Visioffice: 'VisiOffice',
  pgin_Activisu: 'ActiVisu',
  pgin_RVTZeiss: 'RVT Zeiss',
  pgin_ImpressionIST: 'ImpressionIST',
  pgin_IndividualStudio: 'SBM Individual Studio',
  pgin_WinFit: 'WinFit',
  pgin_MagicMirror: 'Magic Mirror',
  pgin_TopConTRK_1P: 'Topcon TRK-1P',
  pgin_BLUAnalisi: 'BluAnalysis',
  pgin_Ecomm_Base: 'E-commerce Base',
  pgin_ImportClientiXLS: 'Import Clienti XLS',
  pgin_ZeissLogOn: 'Zeiss LogOn',
  pgin_Rfid: 'Rfid',
  pgin_DirectMarketing: 'Direct Marketing',
  pgin_LuxotticaStars: 'Luxottica Stars',
  pgin_FocusLab: 'Focus Lab',
  pgin_ExportContabilita: 'Export Contabilità',
  pgin_Nakymanet: 'Nakymanet',
  pgin_iFocusServer: 'iFOCUS10Server',
  pgin_CSO_Phoenix: 'CSO Phoenix',
  pgin_SellOut: 'SellOut',
  pgin_Syncro: 'Syncro',
  pgin_FatturaPA: 'FatturaPA',
  pgin_2WIN: '2WIN Adaptica',
  pgin_Console10: 'FOCUS10Console',
  pgin_Cartier: 'Modulo Cartier',
  pgin_TaxRefund: 'Tax Refund',
  pgin_WinOnline: 'WinOnline',
  pgin_Italianvision: 'Italianvision',
  pgin_TopconOCT: 'Topcon OCT',
  pgin_SbmIpad: 'SBM iPad',
  pgin_EssilorDiretto: 'Essilor Diretto',
  pgin_GViGreenTransitions: 'GV iGreen',
  pgin_IlMioOttico: 'Il Mio Ottico',
  pgin_BluCassa: 'BluCassa',
  pgin_ModuloTS: 'FOCUS TS',
  pgin_ZeissVisustore: 'Zeiss Visustore',
  pgin_LuxotticaRXO: 'Luxottica RXO',
  pgin_IlMioOtticoSingolo: 'Il Mio Ottico (S)',
  pgin_RacSystem: 'Rac System',
  pgin_GFK: 'GFK',
  pgin_Ecomm_Pro: 'Ecommerce PRO',
  pgin_Luxottica_NOOS: 'Luxottica NOOS',
  pgin_FatturaB2B: 'FOCUS FE',
  pgin_Tracer: 'Tracer',
  pgin_Essibox2: 'Essibox 2.0',
  pgin_ItalLenti: 'ItalLenti',
  pgin_BluSign: 'Blu Sign',
  pgin_ShamirOnline: 'Shamir Online',
  pgin_BBGRFTP: 'BBGR Acuitis',
  pgin_Visuconsult: 'Visuconsult',
  pgin_ZeissLAC: 'Zeiss Lac',
  pgin_VEM: 'VEM',
  pgin_Jakala: 'Reporting Dashboard',
  pgin_FocusRT1: 'FocusRT1',
  pgin_FocusRT2: 'FocusRT2',
  pgin_FocusRT3: 'FocusRT3',
  pgin_FocusRT4: 'FocusRT4',
  pgin_FocusRT5: 'FocusRT5',
  pgin_FocusRTPlus: 'FocusRTPlus',
  pgin_FocusWEB: 'FOCUS WEB',
  pgin_FocusCRM: 'FOCUS CRM',
  pgin_ZeissBusta: 'Zeiss Busta',
  pgin_Noleggio: 'Noleggio',
  pgin_MarcolinMore: 'Marcolin More',
  pgin_NoleggioVG: 'Noleggio VG',
  pgin_OxoData: 'Oxo Data',
  pgin_HoyaWeb: 'HoyaILog',
  pgin_MersyDiretto: 'Mersy Diretto',
  pgin_Visuconsult500: 'Visuconsult 500',
  pgin_Cnxt: 'Cnxt',
  pgin_Bridge: 'Bridge',
  pgin_BluBooking: 'Blu Booking',
  pgin_BluReport: 'BluReport',
  pgin_Pegaso: 'Pegaso',
  pgin_FocusRT1SaaS: 'FOCUS RT',
  pgin_FocusRT2SaaS: 'FOCUS RT',
  pgin_FocusRT3SaaS: 'FOCUS RT',
  pgin_FocusRT4SaaS: 'FOCUS RT',
  pgin_FocusRT5SaaS: 'FOCUS RT',
  pgin_FocusRTPlusSaaS: 'FOCUS RT',
  pgin_AgendaWeb: 'Agenda Web',

  // nuove aggiunte
  pgin_FocusCloudDB: 'Focus Cloud DB',
  pgin_FocusCloudWP: 'Focus Cloud WP',
  pgin_WhatsApp: 'WhatsApp',
  pgin_WhatsAppCredit: 'WhatsApp Credit',
  pgin_DUMMY_110: 'DUMMY',
  pgin_Sms: 'Sms',
  pgin_SmsCredit: 'Sms Credit',
  pgin_EMail: 'EMail',
  pgin_EMailCredit: 'EMail Credit',
  pgin_AdvancedAI: 'Advanced A.I.',
  pgin_PremiumAI: 'Premium A.I.',
  pgin_AdvancedBI: 'Advanced B.I.',
  pgin_PremiumBI: 'Premium B.I.',
  pgin_API: 'API',
  pgin_DUMMY_120: 'DUMMY',
  pgin_ReplicaDB: 'Replica DB',
  pgin_FocusCloudAPP: 'Focus Cloud APP',

  pgin_FocusCloudFcSession: 'FcSession',
  pgin_CloudConnector: 'CloudConnector', //Focus Cloud APP
  pgin_CrmBase: 'CrmBase', //Focus Cloud APP
  pgin_CloudDataExchange: 'Cloud Data Exchange',
  pgin_Webhook: 'Webhook',

  pgin_RefSystem: 'REF-System',
  pgin_FrastemaKit: 'FrastemaKit',
  pgin_FocusCRMStart: 'Focus CRM Start',
  pgin_CloudStorage: 'Cloud storage',
  pgin_ZeissVisionPlus: 'ZEISS Vision Plus',
  pgin_CloudOrder: 'Cloud Order',
  pgin_OnePortal: 'MyEssilorLuxottica',
  pgin_SmartTraffic: 'SmartTraffic',
  // altre chiavi strane ma esistenti
  chiaveplugin_free: 7850,
  pgin_Assistenza: 99,
  pgin_GVHerzach: 100,
};

/**
 * Controlla se un plugin specificato è attivo.
 *
 * @param {string | number} codicePlugin - Il codice del plugin da verificare.
 * @param {string[]} Plugin - L'array di stringhe contenente i codici dei plugin attivi.
 * @returns {boolean} Ritorna true se il plugin è presente nell'array, altrimenti false.
 */
export const isBludataPluginAttivo = (
  codicePlugin: string | number,
  Plugin: string[],
) => {
  const pginCode = `${codicePlugin}`;
  return Plugin.indexOf(pginCode) >= 0;
};

/**
 * Verifica se un plugin è presente in una lista di plugin.
 *
 * @param {string[]} plugins - L'array di stringhe contenente i codici dei plugin.
 * @param {string | number} codicePlugin - Il codice del plugin da cercare nella lista.
 * @returns {boolean} Ritorna true se il plugin è presente nella lista, altrimenti false.
 */
export const checkPluginFromListaPlugin = (
  plugins: string[],
  codicePlugin: string | number,
) => {
  const pginCode = `${codicePlugin}`;
  return plugins.indexOf(pginCode) >= 0;
};

// ---------------------------------------------------------------------------
// Tier Focus Cloud — Core / Advanced / Premium
// ---------------------------------------------------------------------------

/**
 * Mappa dei plugin discriminanti per ogni tier Focus Cloud.
 *
 * - **core**: plugin che identificano il tier Core (pgin_CrmBase = 125)
 * - **advanced**: plugin esclusivi del tier Advanced (presenti SOLO se non è Core)
 * - **premium**: plugin aggiuntivi che, insieme ai plugin Advanced, identificano il tier Premium
 *
 * I tier sono mutuamente esclusivi: un cliente è Core OPPURE Advanced OPPURE Premium.
 */
export const focusCloudTierPlugins = {
  /** Plugin discriminante tier Core (pgin_CrmBase = 125) */
  core: [pluginCodes.pgin_CrmBase] as readonly number[],
  /** Plugin che identificano il tier Advanced (almeno uno deve essere attivo, con Core NON attivo) */
  advanced: [
    pluginCodes.pgin_AdvancedAI, // 115
    pluginCodes.pgin_AdvancedBI, // 117
    pluginCodes.pgin_BluSign, // 58
    pluginCodes.pgin_FocusCloudAPP, // 122
    pluginCodes.pgin_BluBooking, // 85
  ] as readonly number[],
  /** Plugin aggiuntivi che, combinati con i plugin Advanced, determinano il tier Premium */
  premium: [
    pluginCodes.pgin_PremiumAI, // 116
    pluginCodes.pgin_PremiumBI, // 118
    pluginCodes.pgin_FocusCRM, // 74
  ] as readonly number[],
} as const;

export default pluginCodes;
